/* RSP-POPUP-START v1.0 | ROSELVA signup popup | NEW10 | Klaviyo list UvLpMZ (Email List, single opt-in) | fork of ML popup */
(function () {
  'use strict';
  var KEY = 'rsv_popup_v1';
  var DAY = 86400000;
  var qs = location.search;
  var FORCE = /[?&]rspopup=force/.test(qs);
  var path = location.pathname.toLowerCase();

  /* never on these paths (with or without locale prefix) */
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|account|pages|policies|apps|checkout|checkouts)(?:\/|$)/.test(path)) return;
  if (path.indexOf('/checkouts') !== -1 || path.indexOf('/apps/') !== -1) return;
  /* not for visitors arriving from our own mails */
  if (!FORCE && /utm_source=klaviyo/i.test(qs)) return;

  function st() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  var S = st(), now = Date.now();
  if (!FORCE) {
    if (S.done && now - S.done < 365 * DAY) return;
    if (S.until && now < S.until) return;
  }

  /* locale from URL path; EN-US has no prefix and is the default (Shopify.locale as fallback) */
  var seg = (path.split('/')[1] || '');
  var segMap = { 'de-de': 'de', 'da-dk': 'da', 'pl-pl': 'pl', 'cs-cz': 'cs', 'ro-ro': 'ro', 'es-es': 'es', 'it-it': 'it' };
  var lang = segMap[seg] || null;
  var srcLoc = segMap[seg] ? seg : 'en';

  function init() {
    var dictEl = document.getElementById('RSP-i18n');
    var card = document.getElementById('RSP-card');
    var back = document.getElementById('RSP-backdrop');
    if (!dictEl || !card || !back) return;
    var I18N; try { I18N = JSON.parse(dictEl.textContent); } catch (e) { return; }
    if (!lang) {
      var sl = ((window.Shopify && window.Shopify.locale) || '').split('-')[0].toLowerCase();
      lang = I18N[sl] ? sl : 'en';
      if (segMap[seg] === undefined && sl && I18N[sl]) srcLoc = sl;
    }
    var T = I18N[lang] || I18N.en;
    function put(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
    put('RSP-title', T.title); put('RSP-sub', T.sub);
    put('RSP-fn-l', T.fn); put('RSP-em-l', T.em);
    put('RSP-t-ml', T.min); put('RSP-t-sl', T.sec);
    put('RSP-go', T.cta); put('RSP-no', T.no);
    put('RSP-s-title', T.stitle); put('RSP-s-note', T.snote); put('RSP-s-btn', T.sbtn);
    put('RSP-copy-t', T.copy);
    put('RSP-l1', T.lpre); put('RSP-llink', T.llink); put('RSP-l2', T.lpost);
    var ppHref = (segMap[seg] ? '/' + seg : '') + '/policies/privacy-policy';
    document.getElementById('RSP-llink').setAttribute('href', ppHref);
    document.getElementById('RSP-x').setAttribute('aria-label', T.close);

    /* countdown 03:00, stops at 0:00, form stays usable */
    var left = 180, tick = null;
    function renderT() {
      var m = Math.floor(left / 60), s = left % 60;
      put('RSP-t-m', (m < 10 ? '0' : '') + m);
      put('RSP-t-s', (s < 10 ? '0' : '') + s);
    }
    function startTimer() {
      renderT();
      tick = setInterval(function () {
        left -= 1;
        if (left <= 0) { left = 0; clearInterval(tick); }
        renderT();
      }, 1000);
    }

    var shown = false, prevFocus = null, prevOverflow = '';
    function open() {
      if (shown) return; shown = true;
      prevFocus = document.activeElement;
      back.hidden = false; card.hidden = false;
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        back.className = 'rsp-on'; card.classList.add('rsp-on');
      }); });
      startTimer();
      /* lightweight shown counter (local only; Klaviyo client/events is CORS-blocked, see report) */
      var s = st(); s.shown = (s.shown || 0) + 1; s.lastShown = Date.now(); save(s);
      document.addEventListener('keydown', onKey, true);
    }
    function close(dismiss) {
      back.className = ''; card.classList.remove('rsp-on');
      document.documentElement.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey, true);
      if (tick) clearInterval(tick);
      setTimeout(function () { back.hidden = true; card.hidden = true; }, 330);
      if (prevFocus && prevFocus.focus) { try { prevFocus.focus(); } catch (e) {} }
      if (dismiss) {
        var s = st(); s.n = (s.n || 0) + 1;
        s.until = Date.now() + 7 * DAY;
        save(s);
      }
    }
    function onKey(e) {
      if (e.key === 'Escape') { close(true); return; }
      if (e.key !== 'Tab') return;
      var f = card.querySelectorAll('button,input,[href]');
      var v = []; for (var i = 0; i < f.length; i++) { if (f[i].offsetParent !== null) v.push(f[i]); }
      if (!v.length) return;
      var first = v[0], last = v[v.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
    back.addEventListener('click', function () { close(true); });
    document.getElementById('RSP-x').addEventListener('click', function () { close(true); });
    document.getElementById('RSP-no').addEventListener('click', function () { close(true); });
    document.getElementById('RSP-s-btn').addEventListener('click', function () { close(false); });

    /* copy code: clipboard API + select-on-tap fallback */
    var copyBtn = document.getElementById('RSP-copy');
    copyBtn.addEventListener('click', function () {
      var code = document.getElementById('RSP-code').textContent.trim();
      function ok() {
        var t = document.getElementById('RSP-copy-t');
        t.textContent = T.copied;
        setTimeout(function () { t.textContent = T.copy; }, 2000);
      }
      function fallback() {
        var el = document.getElementById('RSP-code');
        try {
          var rng = document.createRange(); rng.selectNodeContents(el);
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(rng);
          if (document.execCommand && document.execCommand('copy')) ok();
        } catch (e) {}
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(ok, fallback);
      } else { fallback(); }
    });

    /* submit via legacy kmail endpoint (form-encoded = simple request, no CORS preflight; proven in POPUP_REPORT.md) */
    var form = document.getElementById('RSP-form');
    var err = document.getElementById('RSP-err');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = document.getElementById('RSP-em').value.trim();
      var fn = document.getElementById('RSP-fn').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) {
        err.textContent = T.err; err.classList.add('rsp-show'); return;
      }
      err.classList.remove('rsp-show');
      var btn = document.getElementById('RSP-go');
      btn.disabled = true;
      var body = 'g=UvLpMZ&company_id=W4xLhK' +
        '&email=' + encodeURIComponent(em) +
        '&first_name=' + encodeURIComponent(fn) +
        '&%24source=' + encodeURIComponent('ROSELVA Popup ' + srcLoc) +
        '&%24fields=%24source%2Cfirst_name';
      function succeed() {
        form.classList.add('rsp-hide');
        document.getElementById('RSP-success').classList.add('rsp-show');
        if (tick) clearInterval(tick);
        var s = st(); s.done = Date.now(); save(s);
        try { document.getElementById('RSP-s-btn').focus({ preventScroll: true }); } catch (e2) {}
      }
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
        body: body
      }).then(function (r) { return r.json().catch(function () { return { success: r.ok }; }); })
        .then(function (j) {
          btn.disabled = false;
          if (j && j.success !== false) { succeed(); }
          else { err.textContent = T.err; err.classList.add('rsp-show'); }
        })
        .catch(function () { btn.disabled = false; err.textContent = T.err; err.classList.add('rsp-show'); });
    });

    function maybeOpen() {
      try {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          if (c && c.item_count > 0) return;
          open();
        }).catch(function () { open(); });
      } catch (e) { open(); }
    }
    /* trigger: ONLY 35s timer (no scroll trigger) + desktop exit intent; both check /cart.js first */
    if (FORCE) { open(); return; }
    setTimeout(maybeOpen, 35000);
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0 && window.matchMedia('(min-width:768px)').matches) maybeOpen();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* RSP-POPUP-END */
